import AbpBase from "./abpbase";
export class PagedResultDto {
  items: any[] = [];
  totalCount: number = 0;
}

export class EntityDto {
  id: number = 0;
}

export class PagedRequestDto {
  sorting: string = undefined;
  skipCount: number = 0;
  maxResultCount: number = 10;
}
/**
 * 分页页面基类
 */
export default abstract class PagedListBase<
  TPagedRequestDto extends PagedRequestDto,
  TEntityDto
> extends AbpBase {
  public pageSize = 10;
  public currentPage = 1;
  public totalCount: number = 0;

  public isTableLoading = false;
  public list: Array<TEntityDto> | null | undefined = [];

  request!: TPagedRequestDto;

  search(): void {
    this.currentPage = 1;
    this.refresh();
  }

  protected refresh(): void {
    this.getDataPage(this.currentPage);
  }

  protected getDataPage(page: number) {
    this.request.maxResultCount = this.pageSize;
    this.request.skipCount = (page - 1) * this.pageSize;

    this.isTableLoading = true;
    this.getpage(() => {
      this.isTableLoading = false;
    });
  }

  abstract getpage(finishCallback: Function): void;
  showPaging(result: any) {
    this.totalCount = result.totalCount;
  }
}
